
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { CheckCircle } from "lucide-react";
import { toast } from "@/components/ui/use-toast";

interface Props {
  courseId: string;
  isCompleted: boolean;
  onCompleted: () => void;
}

const LearnerCompletionButton = ({
  courseId,
  isCompleted,
  onCompleted,
}: Props) => {
  const [loading, setLoading] = useState(false);

  const markComplete = async () => {
    setLoading(true);
    try {
      const res = await fetch(`/api/learner-course/${courseId}/complete`, {
        method: "POST",
      });
      if (!res.ok) throw new Error(await res.text());
      toast({
        title: "Kursus märgitud lõpetatuks",
        description: "Su progress salvestati edukalt!",
      });
      onCompleted();
    } catch (e: any) {
      toast({
        title: "Viga lõpetamisel",
        description: e?.message ?? "Proovi hiljem uuesti.",
        variant: "destructive",
      });
    } finally {
      setLoading(false);
    }
  };

  return isCompleted ? (
    <div className="flex items-center bg-green-50 border border-green-200 rounded-md p-4 justify-center mt-6">
      <CheckCircle className="mr-2 h-5 w-5 text-green-600" />
      <span className="text-green-800 font-medium">Kursus lõpetatud!</span>
    </div>
  ) : null; // Return null instead of the button when not completed
};

export default LearnerCompletionButton;
